import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  SimpleGrid,
  Stack,
  Text,
  Card,
  CardBody,
  Input,
} from "@chakra-ui/react";

const FoodData102 = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [typeFilter, setTypeFilter] = useState("All");
  const [nameFilter, setNameFilter] = useState("All");
  const [uniqueNames, setUniqueNames] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");

  const customerId = 101;

  // ==============================
  // FETCH FOOD DATA
  // ==============================
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getFoodData/${customerId}`
      );

      const foods = response.data.food || [];

      setData(foods);
      setFilteredData(foods);

      setUniqueNames([
        "All",
        ...new Set(foods.map((item) => item.category)),
      ]);
    } catch (error) {
      console.error("Error fetching food data:", error);
    }
  };

  // ==============================
  // FILTER DATA
  // ==============================
  const filterData = (type, name, search) => {
    let filtered = [...data];

    // Type filter
    if (type !== "All") {
      filtered = filtered.filter(
        (item) => item.type === type
      );
    }

    // Category filter
    if (name !== "All") {
      filtered = filtered.filter(
        (item) => item.category === name
      );
    }

    // Search filter
    if (search) {
      const lowerCaseSearch = search.toLowerCase();

      filtered = filtered.filter((item) => {
        const itemName = item.name?.toLowerCase() || "";
        const itemCode = item.code?.toLowerCase() || "";

        return (
          itemName.includes(lowerCaseSearch) ||
          itemCode.includes(lowerCaseSearch)
        );
      });
    }

    setFilteredData(filtered);
  };

  // ==============================
  // TYPE FILTER
  // ==============================
  const handleTypeFilterChange = (filter) => {
    setTypeFilter(filter);

    filterData(
      filter,
      nameFilter,
      searchQuery
    );
  };

  // ==============================
  // CATEGORY FILTER
  // ==============================
  const handleNameFilterChange = (filter) => {
    setNameFilter(filter);

    filterData(
      typeFilter,
      filter,
      searchQuery
    );
  };

  // ==============================
  // SEARCH
  // ==============================
  const handleSearchChange = (e) => {
    const query = e.target.value;

    setSearchQuery(query);

    filterData(
      typeFilter,
      nameFilter,
      query
    );
  };

  // ==============================
  // INITIAL LOAD
  // ==============================
  useEffect(() => {
    fetchData();
  }, []);

  // ==============================
  // UI
  // ==============================
  return (
    <Box>
      {/* ============================
          SEARCH
      ============================ */}
      <Box
        display="flex"
        justifyContent="center"
        marginBottom="20px"
        gap="10px"
        mt={10}
      >
        <Input
          placeholder="Search by Name"
          value={searchQuery}
          onChange={handleSearchChange}
          width={{
            base: "90%",
            md: "300px",
          }}
        />
      </Box>

      {/* ============================
          TYPE FILTER
      ============================ */}
      <Box
        display="flex"
        justifyContent="center"
        marginBottom="20px"
        gap="10px"
      >
        {["All", "Veg", "Non-Veg"].map(
          (filter) => (
            <Button
              key={filter}
              onClick={() =>
                handleTypeFilterChange(filter)
              }
              colorScheme={
                typeFilter === filter
                  ? "green"
                  : "gray"
              }
              size={{
                base: "sm",
                md: "md",
              }}
            >
              {filter}
            </Button>
          )
        )}
      </Box>

      {/* ============================
          CATEGORY FILTER
      ============================ */}
      <SimpleGrid
        columns={{
          base: 2,
          md: 6,
        }}
        gap="10px"
        mb={5}
      >
        {uniqueNames.map(
          (name, index) => (
            <Button
              key={index}
              onClick={() =>
                handleNameFilterChange(name)
              }
              colorScheme={
                nameFilter === name
                  ? "green"
                  : "gray"
              }
              size={{
                base: "sm",
                md: "md",
              }}
            >
              {name}
            </Button>
          )
        )}
      </SimpleGrid>

      {/* ============================
          FOOD CARDS
      ============================ */}
      <SimpleGrid
        columns={{
          base: 1,
          md: 2,
          lg: 3,
          xl: 5,
        }}
        placeItems="center"
        height="fit-content"
        gap="5px"
        p={2}
      >
        {filteredData.map((item) => (
          <Card
            maxW="sm"
            key={item._id}
            boxShadow="dark-lg"
            mb={3}
            width={{
              base: "90%",
              md: "auto",
            }}
          >
            <CardBody fontFamily="sans-serif">
              <Stack spacing="2">
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="space-between"
                  textAlign="left"
                  p={2}
                >
                  {/* FOOD TYPE */}
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    mb={2}
                  >
                    <Text
                      fontSize="md"
                      fontWeight="bold"
                      color={
                        item.type === "Veg"
                          ? "green.500"
                          : "red.500"
                      }
                    >
                      {item.type}
                    </Text>
                  </Box>

                  {/* FOOD DETAILS */}
                  <Box
                    display="flex"
                    flexDirection="column"
                    gap={2}
                  >
                    <Text fontSize="sm">
                      <b>Name</b>: {item.name}
                    </Text>

                    <Text fontSize="sm">
                      <b>Category</b>:{" "}
                      {item.category}
                    </Text>

                    <Text
                      color="blue.600"
                      fontSize="md"
                    >
                      <b>Rate</b>: ₹{item.acRate}
                    </Text>
                  </Box>
                </Box>
              </Stack>
            </CardBody>
          </Card>
        ))}
      </SimpleGrid>

      {/* ============================
          NO DATA
      ============================ */}
      {filteredData.length === 0 && (
        <Box
          textAlign="center"
          py={10}
        >
          <Text
            fontSize="lg"
            color="gray.500"
          >
            No food items found
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default FoodData102;